import styled from "@emotion/styled";
import { RiExternalLinkLine } from "@remixicon/react";
import { palette, size, space } from "@stedi/dls/constants";
import { fontWeight } from "@stedi/dls/styles";
import { BaseLinkStyle } from "@stedi/dls/TextLink";
import { useRouter } from "next/router";
import { useIsMounted } from "../hooks/useIsMounted";
import {
  getCurrentURLStateQueryParameterValue,
  getPlaygroundLinkForCurrentState,
  getPlaygroundLinkForV1State,
  getV1URLStateQueryParameterValue,
} from "../lib/state";

const SLink = styled.a({
  ...BaseLinkStyle,
  ...fontWeight("normal"),
  fontSize: size.small,
  textDecorationThickness: "auto",
  color: palette.gray11,
  gap: space.s1,
  display: "flex",
  alignItems: "center",
  ":hover, :focus": {
    textDecorationColor: palette.gray11,
  },
});

const EditInPlaygroundLink = () => {
  const playgroundLink = useGetPlaygroundLink();
  /**
   * Since we cannot get the `origin` during SSR, we cannot render the `a` tag.
   * Ensures there are no hydration mismatches (condition on typeof window === "undefined" would cause such mismatch).
   */
  const isMounted = useIsMounted();
  if (!isMounted) {
    return null;
  }

  return (
    <SLink href={playgroundLink} target="_blank">
      Edit in JSONata Playground
      <RiExternalLinkLine size={14} />
    </SLink>
  );
};

export { EditInPlaygroundLink };

const useGetPlaygroundLink = () => {
  const router = useRouter();

  const isMounted = useIsMounted();
  if (!isMounted) {
    return undefined;
  }

  const currentStateParameterValue = getCurrentURLStateQueryParameterValue(router.query);
  if (currentStateParameterValue) {
    return getPlaygroundLinkForCurrentState(currentStateParameterValue);
  }

  const v1StateParameterValue = getV1URLStateQueryParameterValue(router.query);
  return getPlaygroundLinkForV1State(v1StateParameterValue);
};
